/**
 * Created by liyunsong on 2018/3/21.
 */
import React, {Component} from 'react';
import {Router, Route, Switch} from 'react-router-dom';
import history from './history';
import Loadable from 'react-loadable';
import {checkWidthUpApp} from './containers/UpApp';

const LoadingLoadable = loader => Loadable({loading: () => null, loader});
const Home = LoadingLoadable(() => import('./containers/Home'));
const Clips = LoadingLoadable(() => import('./containers/Clips'));
const User = LoadingLoadable(() => import('./containers/User'));
const VideoPage = LoadingLoadable(() => import('./containers/PlayPage'));
const Question = LoadingLoadable(() => import('./containers/Question'));

@checkWidthUpApp
class App extends Component {
  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route exact path="/user" component={User}/>
          <Route exact path="/appointment" component={Clips}/>
          <Route exact path="/video/:id" component={VideoPage}/>
          <Route exact path="/question/:id" component={Question}/>
          <Route component={Home}/>
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx